import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import UserContainer from 'components/user/container/UserContainer';
import { Header } from 'components/atoms/Header/Header';
import Table from 'components/table/Table';
import { formatUnixDate } from 'controls/utils';
import { Language } from 'language/Language';
import { orderDetailsStrings } from './strings';
import 'components/table/_Table.scss';

const Order = () => {
  const { order } = useSelector((state) => state);
  const language = Language();

  const OrderHero = () => (
    <div>
      <p>
        {`${orderDetailsStrings[language].order} `}
        <span className='highlighted-text'>{order.orderID}</span>
        {` ${orderDetailsStrings[language].placed} `}
        <span className='highlighted-text'>{formatUnixDate(order.createdAtUnixEpoch)}</span>
        {` ${orderDetailsStrings[language].currency} `}
        <span className='highlighted-text'>{order.status}</span>
      </p>
    </div>
  );

  return (
    <UserContainer>
      <div style={{ width: '100%' }}>
        {order
          ? (
            <>
              <OrderHero />
              <Header text={orderDetailsStrings[language].title} />
              <Table>
                <>
                  <Table.Header headers={[orderDetailsStrings[language].product, orderDetailsStrings[language].total]} />
                  <Table.Content>
                    <>
                      <div className='table-row'>
                        <div className='table-content__item table-item__long'>
                          <p>{order.entitlements[0] ? order.entitlements[0].name : '360 Reality Audio Creative Suite'}</p>
                        </div>
                        <div className='table-content__item table-item__long'>
                          <h3>{`$${order.total}`}</h3>
                        </div>
                      </div>
                      <div className='table-row table-row__border' style={{ borderTop: '3rem' }}>
                        <div className='table-content__item table-content__min-item'>
                          <h3>{orderDetailsStrings[language].pay}</h3>
                        </div>
                        <div className='table-content__item table-content__min-item'>
                          <h3>PADDLE</h3>
                        </div>
                      </div>
                      <div className='table-row table-row__border '>
                        <div className='table-content__item table-content__min-item'>
                          <h3>{orderDetailsStrings[language].TOTAL}</h3>
                        </div>
                        <div className='table-content__item table-content__min-item'>
                          <h3>{`$${order.total}`}</h3>
                        </div>
                      </div>
                    </>
                  </Table.Content>
                </>
              </Table>
              <Header text={orderDetailsStrings[language].info} />
              <div style={{ border: '1px solid #ccc', padding: '10px' }}>
                <p>{order.user.name}</p>
                <p>
                  <Icon name='mail' size='small' />
                  {order.user.email}
                </p>
              </div>
            </>
          )
          : (<p>No order has been made yet.</p>)}
      </div>
    </UserContainer>
  );
};

export default Order;
